import { api } from '../../constants/api.js';
import { axios } from '../http/axios.js';

const BookingsService = {
    fetchBookings: async () => {
        try {
            const response = await axios.get(api.bookings.fetch);
            return response.data;
        } catch (error) {
            console.error('Error fetching bookings:', error);
            throw error;
        }
    },

    getBookingById: async (id) => {
        try {
            const response = await axios.get(api.bookings.getById(id));
            return response.data;
        } catch (error) {
            console.error(`Error fetching booking with id ${id}:`, error);
            throw error;
        }
    },

    getBookingByProductId: async (id) => {
        try {
            const response = await axios.get(api.bookings.getByProductId(id));
            return response.data;
        } catch (error) {
            console.error(`Error fetching booking with id ${id}:`, error);
            throw error;
        }
    },

    updateBooking: async (id, data) => {
        try {
            // Use PUT since your backend route expects PUT for updates
            const response = await axios.put(api.bookings.update(id), data);
            return response.data;
        } catch (error) {
            console.error(`Error updating booking with id ${id}:`, error);
            throw error;
        }
    },

    updateBookingProduct: async (id, data) => {
        try {
            const response = await axios.put(api.bookings.updateBookingProduct(id), data);
            return response.data;
        } catch (error) {
            console.error(`Error updating booking product with id ${id}:`, error);
            throw error;
        }
    },

    // If you need other CRUD operations for bookings, you can add them similarly:
    // createBooking: async (data) => {
    //     try {
    //         const response = await axios.post(api.bookings.create, data);
    //         return response.data;
    //     } catch (error) {
    //         console.error('Error creating booking:', error);
    //         throw error;
    //     }
    // },

    // updateBooking: async (id, data) => {
    //     try {
    //         const response = await axios.patch(api.bookings.update(id), data);
    //         return response.data;
    //     } catch (error) {
    //         console.error('Error updating booking:', error);
    //         throw error;
    //     }
    // },

    // deleteBooking: async (id) => {
    //     try {
    //         const response = await axios.delete(api.bookings.delete(id));
    //         return response.data;
    //     } catch (error) {
    //         console.error('Error deleting booking:', error);
    //         throw error;
    //     }
    // },
};

export default BookingsService;
